<!-- ── Hero ──────────────────────────────────────────────────────────────── -->
<section class="wn__hero">
  <div class="wn__aurora" aria-hidden="true">
    <aurora-light
      [colorStops]="['#54c4ed', '#a4d165', '#54c4ed']"
      [amplitude]="1.4"
      [blend]="0.5"
      [speed]="2.2"
      [opacity]="0.7"
    />
  </div>

  <sphere-animation />

  <div class="wn__hero-inner">
    <!-- Left: text -->
    <div class="wn__hero-left">
      <h1 class="wn__hero-h1">
        <span class="wn__hero-static">From Intent to</span>
        <span class="wn__hero-rotator-mask">
          <span class="wn__hero-rotator-track">
            <span class="wn__hero-rotator-word">Discovery</span>
            <span class="wn__hero-rotator-word">Connection</span>
            <span class="wn__hero-rotator-word">Reuse</span>
            <span class="wn__hero-rotator-word">Impact</span>
            <span class="wn__hero-rotator-word">Discovery</span>
          </span>
        </span>
      </h1>
      <p class="wn__hero-sub">
        <span class="wn__hero-brand">
          <span class="wn__hero-brand-data">Data</span><span class="wn__hero-brand-nex">Nex+</span>
        </span>
        connects you to ADB's growing ecosystem of data and AI assets, helping you discover and
        build on capabilities that already exist.
      </p>
      <p class="wn__hero-sub">
        Find what you need, build on what's available, and turn knowledge into action.
      </p>
      <button class="wn__hero-cta" (click)="navigateToDiscover()">
        <img
          class="wn__hero-cta-icon"
          src="icons/cta-spark.svg"
          width="16"
          height="16"
          alt=""
          aria-hidden="true"
        />
        <span class="wn__hero-cta-text">Start Discovering</span>
      </button>
    </div>

    <!-- Right: product trailer video -->
    <div class="wn__hero-video" aria-label="Product walkthrough">
      <video
        #heroVideo
        class="wn__hero-video-player"
        [src]="trailerUrl"
        [muted]="true"
        autoplay
        loop
        playsinline
        (mouseenter)="heroVideo.controls = true"
        (mouseleave)="heroVideo.controls = false"
        aria-label="DataNex+ product trailer"
      ></video>
    </div>
  </div>
</section>

<!-- ── Better Decisions ──────────────────────────────────────────────────── -->
<section class="wn__value wn__reveal">
  <div class="wn__value-head">
    <h2 class="wn__value-h2">Better Decisions, Greater Impact</h2>
  </div>
  <div class="wn__value-cards">
    @for (tab of tabs(); track tab.id) {
      <gs-value-card
        [tabId]="tab.id"
        [accent]="tabContent()[tab.id].accent"
        [titleRest]="tabContent()[tab.id].titleRest"
        [body]="tabContent()[tab.id].body"
      />
    }
  </div>
</section>

<!-- ── Assets ─────────────────────────────────────────────────────────────── -->
<section class="wn__assets wn__reveal">
  <div class="wn__assets-inner">
    <p class="wn__assets-statement">
      Over <span class="wn__assets-count" data-target="100" data-suffix="+">0</span> assets, across
      all ADB sectors
    </p>
    <button class="app-primary-btn" (click)="navigateToAssets()">Explore All Assets</button>
  </div>
</section>

<!-- ── Contribute ─────────────────────────────────────────────────────────── -->
<section class="wn__contribute wn__reveal">
  <div class="wn__contribute-card">
    <div class="wn__contribute-inner">
      <h2 class="wn__contribute-h2">Contribute to the DataNex+ Asset Catalog</h2>
      <p class="wn__contribute-sub">
        Have a dataset, AI tool, digital product, knowledge resource, or reusable component that
        could benefit others? Contribute it to DataNex+ to help colleagues discover, reuse, and
        build on capabilities from across ADB. By growing the catalog together, we can reduce
        duplication and make valuable institutional assets easier to find and use.
      </p>
      <contribute-asset-button />
    </div>
  </div>
</section>

<!-- ── What's Next ────────────────────────────────────────────────────────── -->
<section class="wn__next">
  <div class="wn__next-head wn__reveal">
    <h2 class="wn__next-h2">What&rsquo;s Next</h2>
  </div>

  <div class="wn__progress wn__reveal">
    <p class="wn__progress-date">This Release: October <span class="lining-nums">2026</span></p>
    <h3 class="wn__progress-title">Foundation for Discovery</h3>
    <p class="wn__progress-body">
      DataNex+ establishes a unified catalog and AI-guided experience that enables enterprise-wide
      asset discovery, making trusted datasets, AI products, tools, and agents easier to find,
      understand, and access.
    </p>
  </div>

  <div class="wn__next-divider"></div>
  <div class="wn__next-eyebrow wn__reveal">Coming Up</div>

  <div class="wn__roadmap wn__reveal">
    @for (item of roadmapItems(); track item.quarter; let i = $index) {
      <gs-roadmap-card [item]="item" [cardIndex]="i" />
    }
  </div>
</section>
